import Vue from 'vue';
import materialTransformer from './../../transformers/material';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(materialTransformer.fetch(errors));
};

export default (id, material) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/production/material/${id}`, material)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/material/update.js